module.exports = __webpack_public_path__ + "img/1-11.033b92e9.png";